export const formatCurrency = (value) => {
  if (value == null || value === '') return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatCompactCurrency = (value) => {
  if (value == null || value === '') return '—';
  const num = Number(value);
  if (Number.isNaN(num)) return '—';
  if (num >= 1000) {
    return `$${Math.round(num / 1000)}K`;
  }
  return formatCurrency(num);
};

export const formatDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
};

export const formatTimeDuration = (years, months) => {
  if (years == null && months == null) return '—';
  const y = years ?? 0;
  const m = months ?? 0;
  const yearLabel = y === 1 ? '1 year' : `${y} years`;
  const monthLabel = m === 1 ? '1 month' : `${m} months`;
  return `${yearLabel}, ${monthLabel}`;
};

export const getClientInitials = (name) => {
  if (!name) return 'CL';
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');
};

export const profileBadgeLabel = (profile, index) => {
  if (profile.isPrimary) return 'Primary';
  if (profile.ownershipPercentage && profile.ownershipPercentage < 100) return `Owner ${index + 1}`;
  if (index > 0) return `Business ${index + 1}`;
  return 'Owner';
};

export const profileSummary = (profile) => {
  const parts = [];
  if (profile.ownerName) parts.push(profile.ownerName);
  if (profile.businessLegalName) parts.push(profile.businessLegalName);
  return parts.join(' • ') || 'No summary yet';
};
